<script setup lang="ts">
/** Shown after an account is deleted (U-2), over whatever is underneath, until the creator taps Done. */
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import FullScreenNotice from '@/components/gates/FullScreenNotice.vue'
import { ACCOUNT_DELETED_COPY, accountDeletedNotice, dismissAccountDeletedNotice } from '@/native/accountDeletion'
import { isCompanionApp } from '@/native/companion'

const router = useRouter()
const copy = computed(() => (accountDeletedNotice.value ? ACCOUNT_DELETED_COPY[accountDeletedNotice.value] : null))

function done(): void {
    dismissAccountDeletedNotice()
    void router.replace(isCompanionApp() ? { name: 'native-login' } : { path: '/' }).catch(() => {})
}
</script>

<template>
    <FullScreenNotice
        v-if="copy"
        overlay
        :title="copy.title"
        :body="copy.body"
        icon="fa-regular fa-circle-check"
        data-testid="account-deleted"
    >
        <button v-press type="button" class="fsn-btn fsn-btn--primary" @click="done">Done</button>
    </FullScreenNotice>
</template>
